import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { adminAuth } from '../../helpers/api/adminApi';

interface AdminTopbarProps {
    onToggleSidebar: () => void;
}

const AdminTopbar: React.FC<AdminTopbarProps> = ({ onToggleSidebar }) => {
    const location = useLocation();
    const admin = adminAuth.getUser();

    const getPageTitle = () => {
        const path = location.pathname;
        if (path === '/admin/dashboard' || path === '/admin') return 'Platform Dashboard';
        if (path.includes('/customers/users')) return 'Customers / User Management';
        if (path.includes('/customers/workspaces')) return 'Customers / Workspaces';
        if (path.includes('/subscriptions/usage')) return 'Subscriptions / Credits & Usage';
        if (path.includes('/subscriptions')) return 'Subscriptions / Plan Management';
        if (path.includes('/whatsapp/accounts')) return 'WhatsApp / Connected Accounts';
        if (path.includes('/whatsapp/message-logs')) return 'WhatsApp / Message Logs';
        if (path.includes('/ai/usage')) return 'AI / Platform Token Usage';
        if (path.includes('/ai/providers')) return 'AI / Model Provider Status';
        if (path.includes('/mcp/servers')) return 'MCP / Server Orchestration';
        if (path.includes('/mcp/tools')) return 'MCP / Discovered Tools';
        if (path.includes('/mcp/executions')) return 'MCP / Execution Logs';
        if (path.includes('/automation/executions')) return 'Automation / Execution History';
        if (path.includes('/automation/list')) return 'Automation / Customer Workflows';
        if (path.includes('/settings/roles')) return 'Settings / Role Management';
        if (path.includes('/settings/permissions')) return 'Settings / Permissions Matrix';
        if (path.includes('/settings/audit-logs')) return 'Settings / Administrative Audit Logs';
        if (path.includes('/settings/system')) return 'Settings / Platform System Settings';
        if (path.includes('/profile')) return 'Administrator Profile';
        return 'Super Admin Console';
    };

    const handleLogout = () => {
        adminAuth.clearSession();
        window.location.href = '/admin/login';
    };

    return (
        <header className="admin-topbar">
            <div className="admin-topbar-left">
                <button className="btn btn-icon admin-menu-btn" onClick={onToggleSidebar} title="Toggle Sidebar">
                    <FeatherIcon icon="menu" size="20" />
                </button>
                <div className="admin-page-heading">
                    <h5 className="mb-0 text-dark fw-bold">{getPageTitle()}</h5>
                    <span className="text-muted small">Global Administrative Center</span>
                </div>
            </div>

            <div className="admin-topbar-right">
                <div className="admin-status-pill d-none d-sm-flex align-items-center me-3">
                    <span className="status-dot online"></span>
                    <span className="small text-muted fw-semibold">Live Production</span>
                </div>

                <div className="dropdown me-2">
                    <Link to="/admin/profile" className="admin-profile-badge text-decoration-none">
                        <div className="admin-avatar-sm">
                            {admin?.name ? admin.name.charAt(0).toUpperCase() : 'A'}
                        </div>
                        <div className="admin-profile-info d-none d-md-block text-start">
                            <span className="admin-name d-block fw-bold text-dark">{admin?.name || 'Administrator'}</span>
                            <span className="admin-role-badge">{admin?.role || 'Super Admin'}</span>
                        </div>
                    </Link>
                </div>

                <button 
                    onClick={handleLogout} 
                    className="btn btn-outline-danger btn-sm d-flex align-items-center gap-1"
                    title="Sign Out of Super Admin"
                >
                    <FeatherIcon icon="log-out" size="14" />
                    <span className="d-none d-md-inline">Logout</span>
                </button>
            </div>
        </header>
    );
};

export default AdminTopbar;
